export class Regions {
    constructor(
        public regionId: number, 
        public startTime: number, 
        public endTime: number,
        public regionPercentage: string,
        public regionText: string
    ) {}
  }
  